import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useDeleteUser } from '../lib/use-delete-user'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'

type DeleteUserAlertProps = {
  selectUserId: number
  onCloseModal: () => void
}

export const DeleteUserAlert: FC<DeleteUserAlertProps & AlertDialogProps> = ({
  selectUserId,
  onCloseModal,
  ...props
}) => {
  const { isLoadingDelete, handleDeleteUser } = useDeleteUser()
  const { t } = useTranslation(['userManagement'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('userManagement:confirmation.are_you_absolutely_sure')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('userManagement:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('userManagement:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteUser(selectUserId, onCloseModal)}
          >
            {isLoadingDelete ? (
              <Loader color='white' size='xs' />
            ) : (
              t('userManagement:buttons.delete')
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
